import { TemplateRawForm, TemplateRawFormField } from '../interfaces/template-raw-form';
import { TEMPLATE_FORM_FIELD_REGISTRY } from '../registry/templateFormFieldRegistry';
import { TemplateFormFieldEnum } from '../interfaces/template-form-field';
import { TemplateFormRenderExpressionFactory } from './templateFormRenderExpressionFactory';

import { TemplateFormField, TemplateFormMode } from '../interfaces/template-form';

export function TemplateFormFieldFactory(
  field: TemplateRawFormField,
  mode: TemplateFormMode,
  formMeta?: TemplateRawForm['template']['metadata']
): TemplateFormField {
  const rawComponent = (field.component?.type || field.type) as TemplateFormFieldEnum;
  const componentMeta = TEMPLATE_FORM_FIELD_REGISTRY[rawComponent];

  const disableFieldEdit = isFieldDisabled(field, mode);

  const fieldProps: TemplateFormField['props'] = {
    id: field.name,
    name: field.name,
    required: field.required || false,
    formMode: mode,
    metadata: componentMeta.MetadataFactory(field, disableFieldEdit, formMeta)
  };

  return {
    size: field.size,
    component: componentMeta.component,
    props: fieldProps,
    order: field.group.field_order,
    rowBreak: field.row_break,
    renderExpression: TemplateFormRenderExpressionFactory(field.render_if),
    validationSchema: componentMeta.ValidationSchemaFactory(field)
  };
}

function isFieldDisabled(field: TemplateRawFormField, mode: TemplateFormMode) {
  switch (mode) {
    case 'CREATE':
      return false;

    case 'EDIT':
      return !field.is_eligible_for_edit;

    case 'VIEW':
      return true;

    default:
      return false;
  }
}
